import { EventEmitter } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { InfluencerService } from '../../../../services/influencer/influencer.service';
import { StringUtils } from '../../../../utils/string.utils';
import { TranslateService } from '@ngx-translate/core';
var PlatformSelectComponent = /** @class */ (function () {
    function PlatformSelectComponent(userService, influencerService, translate) {
        this.userService = userService;
        this.influencerService = influencerService;
        this.translate = translate;
        this.showSelectedChannel = false;
        this.changePlatformEvent = new EventEmitter();
        this.platformsOption = [];
    }
    PlatformSelectComponent.prototype.ngOnInit = function () {
        this.currentInfluencer = this.userService.getInfluencerInfo();
        if (this.currentInfluencer) {
            this.fetchListChannel(this.currentInfluencer.id);
        }
        else if (this.influencerId) {
            this.fetchListChannel(this.influencerId);
        }
    };
    PlatformSelectComponent.prototype.fetchListChannel = function (influencerId) {
        var _this = this;
        this.influencerService.fetchListChannel(influencerId)
            .subscribe(function (res) {
            _this.platformsOption = [{
                    id: 0,
                    name: _this.translate.instant('channel_specific.placeholder'),
                    platformName: ''
                }].concat(res);
            if (_this.platformsOption.length > 0) {
                var currentActiveChannel_1 = _this.influencerService.currentActiveChannel;
                var selectedChannel = void 0;
                if (currentActiveChannel_1) {
                    selectedChannel = _this.platformsOption.find(function (p) { return p.id === currentActiveChannel_1.id; });
                }
                if (!selectedChannel) {
                    selectedChannel = _this.platformsOption[0];
                }
                _this.activeChannelId = selectedChannel.id;
                _this.activeChannelName = selectedChannel.platformName.toLowerCase();
                _this.changePlatformEvent.emit(selectedChannel);
            }
        });
    };
    PlatformSelectComponent.prototype.onChangePlatform = function (evt) {
        if (evt) {
            this.changePlatformEvent.emit(evt);
            this.activeChannelName = evt.platformName.toLowerCase();
        }
    };
    PlatformSelectComponent.prototype.capitalizePlatformName = function (platformName) {
        return StringUtils.capitalize(platformName);
    };
    Object.defineProperty(PlatformSelectComponent.prototype, "channelContent", {
        get: function () {
            var _this = this;
            if (!this.activeChannelName || this.activeChannelName === '') {
                return this.translate.instant('profile.show_all');
            }
            var selectedChannel = this.platformsOption.find(function (p) { return p.id === _this.activeChannelId; });
            if (!selectedChannel) {
                return null;
            }
            return this.showSelectedChannel ? selectedChannel.handle : this.translate.instant('profile.show') + " " + selectedChannel.handle;
        },
        enumerable: true,
        configurable: true
    });
    return PlatformSelectComponent;
}());
export { PlatformSelectComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/platform-select/platform-select.component.ts.pre-build-optimizer.js